import React, { useState, useEffect } from "react";
import {
  CardTitle,
} from "reactstrap";
//redux
import { connect } from "react-redux";
//paginação
import Pagination from "../../../../components/Paginationv3";
// backdrops
import Alert from '../../../../components/Backdrops/Alert';
import Loading from '../../../../components/Backdrops/Loading';
// router
import { useLocation } from "react-router-dom";
//service
import faceRecognitionAwsService from "../../../../utils/services/accreditation/faceRecognitionAws";
import plusXMiceIdService from "../../../../utils/services/accreditation/plusXMiceId";
import PlusXMiceIdModel from '../../../../utils/models/PlusXMiceIdModel';
import writeXlsxFile from "write-excel-file";
import moment from 'moment';

import CommandButtons from './CommandButtons';
import EventNotActive from './EventNotActive';
import GuestsList from './GuestsList';

function LeadCollectorReports(props) {

  const location = useLocation();
  const eventId = location.state.idEvent;

  const [loadingControl, setLoadingControl] = useState({
    open: false,
    message: '',
  });
  const [alertControl, setAlertControl] = useState({
    open: false,
    title: '',
    message: '',
    status: '', // success, warning, error
  });
  const [plusXMiceId, setPlusXMiceId] = useState(PlusXMiceIdModel());
  const plusXMiceIdRef = React.useRef(PlusXMiceIdModel());
  const [guestsList, setGuestsList] = useState([]);
  // loading
  const [loading, setLoading] = useState(false);
  const [searchControl, setSearchControl] = React.useState({
    search: '',
    filter: 'all',
    total: 0,
  });
  const searchControlRef = React.useRef(searchControl);
  React.useEffect(() => {
    searchControlRef.current = searchControl;
  }, [searchControl]);
  const lastSearchStringUpdate = React.useRef(Date.now());
  const [currentIndex, setCurrentIndex] = useState(1);
  const currentIndexRef = React.useRef(currentIndex);
  const isMountedRef = React.useRef(false);
  React.useEffect(() => {
    currentIndexRef.current = currentIndex;
    if (isMountedRef.current) {
      getData();
    }
  }, [currentIndex]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const itemsPerPageRef = React.useRef(itemsPerPage);
  React.useEffect(() => {
    itemsPerPageRef.current = itemsPerPage;
    if (isMountedRef.current) {
      getData();
    }
  }, [itemsPerPage]);

  useEffect(() => {
    isMountedRef.current = true;
    getData();
  }, []);

  const getData = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Carregando' });

      let _plusXMiceId = { ...plusXMiceIdRef.current };
      if (!_plusXMiceId.miceId) {
        _plusXMiceId = await plusXMiceIdService.getPlusXMiceId(eventId);
        plusXMiceIdRef.current = _plusXMiceId;
        setPlusXMiceId(_plusXMiceId);
        if (!_plusXMiceId.active) {
          return;
        }
      }

      let _offset = (currentIndexRef.current - 1) * itemsPerPageRef.current;
      let _guests = await faceRecognitionAwsService.getGuestsByAwsFaceIds(
        _plusXMiceId.miceId,
        itemsPerPageRef.current,
        _offset,
        searchControlRef.current.search,
        searchControlRef.current.filter,
      );

      setGuestsList(_guests.data);
      setSearchControl({ ...searchControlRef.current, total: _guests.count });

    } catch (error) {
      console.log('Error getData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }
  }, []);

  const getReport = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Buscando' });

      const _guestsList = await getGuestsList();

      await createXlsx(_guestsList);

    } catch (error) {
      console.log('Error getData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }

    async function getGuestsList() {
      let _offset = 0;
      let _perPage = 2;
      let _guestsList = [];
      let _guestsCount = 0;
      do {
        let _guests = await faceRecognitionAwsService.getGuestsByAwsFaceIds(
          plusXMiceId.miceId,
          _perPage,
          _offset,
          '',
          'all',
        );
        _offset += _perPage;
        _guestsList = [..._guestsList, ..._guests.data];
        _guestsCount = _guests.count;

      } while (_guestsCount > _guestsList.length);
      return _guestsList;
    }

    async function createXlsx(list = []) {
      const schema = [
        {
          column: "ID",
          type: String,
          value: (guest) => guest.id.toString(),
        },
        {
          column: "Nome",
          type: String,
          value: (guest) => guest.name,
        },
        {
          column: "E-mail",
          type: String,
          value: (guest) => guest.email,
        },
        {
          column: "Possui Face ID?",
          type: String,
          value: (guest) => (guest.hasFace ? "Sim" : "Não"),
        },
      ];

      await writeXlsxFile(list, {
        schema,
        fileName: `Relatório Face ID Evento ${plusXMiceId.miceId} - ${moment().format('YYYY-MM-DD HH-MM')}.xlsx`,
      });
    }
  }, [plusXMiceId]);

  if (!plusXMiceId.active) {
    return (
      <EventNotActive />
    )
  }
  return (
    <div>
      <CardTitle>Cadastros de Face ID</CardTitle>
      <CommandButtons
        searchControl={searchControl}
        setSearchControl={setSearchControl}
        lastSearchStringUpdate={lastSearchStringUpdate}
        getData={getData}
        getReport={getReport}
      />
      <GuestsList
        guestsList={guestsList}
        loading={loading}
      />
      <Pagination
        data={guestsList}
        search={searchControl.search}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        countData={searchControl.total}
        maxItemPerPage={itemsPerPage}
        setMaxItemPerPage={setItemsPerPage}
        maxPageButtonsToShow={3}
      />

      <Loading loadingControl={loadingControl} />
      <Alert
        alertControl={alertControl}
        setAlertControl={setAlertControl}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(LeadCollectorReports);
